import { useEffect, useState } from "react";
import {
    List,
    Datagrid,
    TextField,
    TextInput,
    TopToolbar,
    DateField,
    DateInput,
    Button,
    useDataProvider,
    SelectInput,
    useListContext,
    FunctionField,
    useNotify,
    useRefresh,
} from "react-admin";
import { Typography } from "@mui/material";
import { LogisticsDialog } from "../../Components/LogisticsDialog";

const ListActions = ({ customerTypeChoices }) => {
    const { setFilters, filterValues } = useListContext();  // 获取列表上下文
    const initialFilters = { status: '2' };  // 初始过滤器值
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const refresh = useRefresh();

    // 重置过滤器函数
    const handleResetFilters = () => {
        setFilters(initialFilters);
    };

    const handleExport = async () => {
        if (window.confirm(`确认导出内容？`)) {
            await dataProvider.exportOutStockSn({
                ...filterValues
            }).then(res => {
                notify('导出成功', { type: 'success' });
                refresh();
            }).catch(error => {
                notify(`导出失败: ${error.message}`, { type: 'error' });
            })
        }
    };

    return (
        <TopToolbar>
            <Button
                label="重置搜索"
                onClick={handleResetFilters}
                disabled={Object.keys(filterValues).length === 0}  // 当没有过滤条件时禁用
            />
            <Button
                label="导出"
                onClick={handleExport}
            />
        </TopToolbar>
    );
};

const ClickableLogisticsInfo = ({ record }) => {
    const [dialogOpen, setDialogOpen] = useState(false);

    const handleClick = () => {
        if (record.logisticsNo) {
            setDialogOpen(true);
        }
    };

    return (
        <>
            <Typography
                variant="body2"
                onClick={handleClick}
                sx={{
                    cursor: record.logisticsNo ? 'pointer' : 'default',
                    color: record.logisticsNo ? 'primary.main' : 'text.primary',
                    textDecoration: record.logisticsNo ? 'underline' : 'none',
                    whiteSpace: 'nowrap',
                }}
            >
                {record.logisticsNo || '无'}
            </Typography>

            <LogisticsDialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                logisticsNo={record.logisticsNo}
            />
        </>
    );
};


export const outboundQueryList = () => {
    const dataProvider = useDataProvider(); // 获取 dataProvider 实例
    const [customerTypeChoices, setCustomerTypeChoices] = useState([]);
    useEffect(() => {
        // 异步获取客户类型数据
        const fetchCustomerTypes = async () => {
            try {
                const types = await dataProvider.getSalesCustomers();
                setCustomerTypeChoices(types);
            } catch (error) {
                console.error("获取客户类型失败:", error);
            }
        };

        fetchCustomerTypes();
    }, []);  // 空依赖数组确保只调用一次


    let postFilters = [
        <TextInput label="设备SN" alwaysOn source="sn" />,
        <TextInput label="订单号" alwaysOn source="orderNo" />,
        <SelectInput
            alwaysOn
            source="saleCustomerId"
            label="设备商家"
            choices={customerTypeChoices}
        />,
        <DateInput label="出库开始日期" alwaysOn source="outStockStartDate" />,
        <DateInput label="出库结束日期" alwaysOn source="outStockEndDate" />,
        <TextInput label="出库批次号" alwaysOn source="outStockBatchNo" />,
    ];

    return (
        <List filter={{ status: '2' }} filters={postFilters} actions={<ListActions customerTypeChoices={customerTypeChoices} />} empty={false}>
            <Datagrid bulkActionButtons={false}>
                <TextField source="id" label="序号" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="sn" label="设备SN" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="deviceType" label="设备类型" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="productModel" label="产品型号" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />

                <TextField source="outStockBatchNo" label="出库批次号" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="orderNo" label="所属订单号" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <DateField source="outStockTime" label="出库时间" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <DateField source="productionDate" label="生产日期" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="manufacturerName" label="制造工厂" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="salesCustomerName" label="收货方" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <FunctionField
                    label="物流信息"
                    sortable={false}
                    render={(record) => (
                        <ClickableLogisticsInfo record={record} />
                    )}
                    sx={{
                        whiteSpace: 'nowrap',
                    }}
                />

            </Datagrid>
        </List>
    )
}